import Vue from 'vue'
import L from 'leaflet'

export function intPopup(component, data) {
  const info = Vue.extend(component)
  const pop = new info({
    propsData: {
      data
    }
  })

  pop.$mount()
  return pop.$el
}



export function initMarker(img, point) {

  const icon = L.divIcon({
    html: L.Util.template(`<img style="width: 25px" src="${img}" alt="">`),
    iconSize    : [30, 40],
  })
  const latlng = new L.LatLng(point.latitude, point.longitude)
  return L.marker(latlng, {icon: icon})
}